import { createGlobalStyle } from 'styled-components';

import * as colors from './Colors';

const GlobalStyle = createGlobalStyle`
  * {
	  box-sizing: border-box;
  }

  a {
    color: ${colors.quickblue};
  }

  p {
    font-family: "Cera Basic", Arial, Helvetica, sans-serif;
  }

  address {
    font-style: normal;
  }
`;

export default GlobalStyle;
